
const State = {
    actions : [],
    path : [],
    overrides : {},
    target : null
};

export default State;



//////////////////
// WEBPACK FOOTER
// /Users/Jovan/TitanNanoDE/node_modules/@af-modules/router/lib/State.js
// module id = 48
// module chunks = 0